import { render, staticRenderFns } from "./SalesOrderModal.vue?vue&type=template&id=dae3336a&scoped=true"
import script from "./SalesOrderModal.vue?vue&type=script&lang=js"
export * from "./SalesOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae3336a",
  null
  
)

export default component.exports